export const microreelsListText = {
  title: 'Microreels',
  create: 'Create microreels',
  open: 'Open',
  courseEditor: 'Course editor',
  preview: 'Preview',
  editVideo: 'Edit video',
  editVideoInCourseEditor: 'Edit in the course editor',
  editInfo: 'Edit info',
  moveToProject: 'Move to project',
  delete: 'Delete',
  unmute: 'Tap for sound',
  reelsCount: (count: number) =>
    `${count} ${count === 1 ? 'microreel' : 'microreels'}`,
  updatedAgo: (timeAgo: string) => `Updated ${timeAgo}`,
  notShared: 'Not shared',
  viewLearnerProgress: 'View learner progress',
  generating: 'Generating microreels',
  generatingHint: 'This usually takes a few minutes',
  preparingTitle: 'Preparing your microreels',
  preparingHint:
    "This can take a few minutes. You can leave the page — we'll notify you when it's ready.",
  gettingReady: 'Getting things ready',
  cancelGeneration: 'Cancel generation',
  cancelGenerationConfirm:
    'Cancel generating microreels? Every generation still in progress will be discarded and the credits already spent may not be refunded.',
  generationCanceled: 'Generation canceled',
  emptyTitle: 'No microreels yet',
  emptySubtitle: 'Generated microreels will appear here.',
  deleteReel: 'Are you sure you want to delete this microreel?',
  deleteLastReel:
    'This is the last microreel in the group. Deleting it will remove the entire group. Continue?',
  deleteGroup:
    'Are you sure you want to delete this microreel group? All microreels inside will be removed.',
  deleteReelSuccess: 'Microreel deleted',
  deleteGroupSuccess: 'Microreel group deleted',
  editInfoTitle: 'Edit microreel info',
  editGroupInfoTitle: 'Edit microreel collection details',
  editInfoTitleField: 'Title',
  editInfoTitlePlaceholder: 'Microreel title',
  editInfoDescriptionField: 'Description',
  editInfoDescriptionPlaceholder: 'Short description',
  reelPosterHeading: 'Microreel poster',
  groupPosterHeading: 'Microreels poster',
  posterReplace: 'Replace',
  posterRemove: 'Remove',
  posterEmptyTitle: 'Click to select an image',
  posterEmptyHint: 'JPG or PNG, 9:16 works best',
  posterGroupEmptyHint: 'JPG or PNG, 16:9 works best',
  reelPosterHint: 'Shown in the feed before the reel plays.',
  reelPosterEmptyHint: 'Optional, the frame taken from the video is used.',
  groupPosterHint: 'Shown on the microreels card.',
  groupPosterEmptyHint: 'Optional, the first reel poster is used.',
  editInfoSuccess: 'Microreel info updated',
  save: 'Save',
  cancel: 'Cancel',
  learners: 'Learners',
  manageLearners: 'Manage learners',
  publish: 'Publish',
  republish: 'Republish',
  publishSuccess: 'Microreels published',
  republishSuccess: 'Microreels republished',
  learnersNeedPublish: 'Publish the microreels before enrolling learners',
  learnersModalTitle: (groupTitle: string) => `Learners of ${groupTitle}`,
  learnersModalSubtitle:
    'Enroll learners so this microreel shows up in their feed.',
  addLearnersTab: 'Add learners +',
  enrolledLearnersTab: 'Enrolled',
  learnersCount: (count: number) =>
    `${count} ${count === 1 ? 'learner' : 'learners'}`,
  close: 'Close',
  enrollSelected: 'Enroll selected',
  removeSelected: 'Remove selected',
  selectToEnroll: 'Select learners to enroll.',
  selectedCount: (count: number) => `${count} selected`,
  enrolledFooter: (count: number) => `${count} enrolled in this microreel.`,
  selectGroupsToEnroll: 'Select groups to enroll.',
  enrollSuccess: 'Learner(s) enrolled',
  removeLearnersSuccess: 'Learner(s) removed',
  removeLearnersError: 'There was an issue removing learner(s)',
  emptyNoCandidatesTitle: 'No learners to add',
  emptyNoCandidatesText:
    'Everyone in this group is already enrolled in this microreel.',
  inviteToWorkspace: 'Invite learners to workspace',
  emptySearchTitle: 'No learners match your search',
  emptySearchText: 'Check the spelling or search by email domain instead.',
  clearSearch: 'Clear search',
  emptyEnrolledTitle: 'No one is enrolled yet',
  emptyEnrolledText:
    'Pick learners in the Add learners tab and they will see this microreel in their feed.',
  groupPreviewHint:
    'Tap a microreel to preview it exactly as a learner sees it on mobile.',
  nowPlaying: 'Now playing',
  previewPosition: (groupTitle: string, current: number, total: number) =>
    `${groupTitle} · microreel ${current}/${total}`,
  previousReel: 'Previous microreel',
  nextReel: 'Next microreel',
  previewEmpty: 'Select a microreel to preview it here.',
  previewNoVideo: 'This microreel has no playable video yet.',
  fillFrame: 'Fill the screen (crops the sides)',
  fitToFrame: 'Fit the whole video',
  allMicroreels: 'All microreels',
  edit: 'Edit',
  analytics: 'Analytics',
  analyticsNeedPublish: 'Publish the microreels to see analytics',
  moveUp: 'Move up',
  moveDown: 'Move down',
  orderSaved: 'Order updated',
  savedChip: 'SAVED',
  draftChip: 'DRAFT',
  editedAgo: (timeAgo: string) => `edited ${timeAgo}`,
  totalDuration: (duration: string) => `${duration} total`,
  totalDurationLong: (duration: string) => `${duration} in total`,
  questionsCount: (count: number) =>
    `${count} ${count === 1 ? 'question' : 'questions'}`,
  reelDuration: (duration: string) => `Duration: ${duration}`,
  microreelsHeading: 'Microreels',
  dragOrderHint: 'Drag order with the arrows',
  detailsSubject: 'Subject',
  detailsUpdated: 'Updated',
  details: 'Details',
  viewDetails: 'View details',
  addToCourse: 'Add to course',
  share: 'Share',
  previewNeedsPublish: 'Publish the microreels to preview them as a learner',
  statsEnrolled: 'Enrolled',
  statsCompleted: 'Completed',
  statsAvgGrade: 'Avg. grade',
  getInFrontTitle: 'Get them in front of learners',
  getInFrontHint:
    'Send them out directly, or fold them into an existing course.',
  shareWithLearners: 'Share with learners',
  shareToCourse: 'Share to course',
  shareToCourseTitle: 'Add to a course',
  shareToCourseSubtitle: (groupTitle: string) =>
    `Copy ${groupTitle} into one of your courses. The microreels arrive as drafts, so publish the course when you want its learners to see them.`,
  searchCourses: 'Search courses',
  courseSection: 'Section',
  courseSectionFallback: (structure: string, index: number) =>
    `${structure || 'Section'} ${index}`,
  newSectionHint: (name: string) =>
    `This course has no sections yet. A section called "${name}" will be created for the microreels.`,
  loadingSections: 'Loading sections…',
  gradableCourse: 'Gradable',
  participationCourse: 'Participation',
  courseLessonsCount: (count: number) =>
    `${count} ${count === 1 ? 'lesson' : 'lessons'}`,
  coursePublished: 'Published',
  courseDraft: 'Draft',
  gradableCourseOnly:
    'Knowledge checks are graded, so they can only go into a gradable course',
  selectCourse: 'Select the course to add these microreels to.',
  addingToCourse: (courseTitle: string) => `Adding to ${courseTitle}`,
  noCoursesTitle: 'No courses yet',
  noCoursesText: 'Create a course first, then add these microreels to it.',
  createCourse: 'Create course',
  emptyCourseSearchTitle: 'No courses match your search',
  emptyCourseSearchText: 'Check the spelling or try a shorter search.',
  addedToCourseTitle: (count: number, courseTitle: string) =>
    `Added ${count} ${
      count === 1 ? 'microreel' : 'microreels'
    } to ${courseTitle}`,
  addedToCourseText:
    'They are drafts in the course for now. Publish the course when you want its learners to see them.',
  openCourse: 'Open course',
  done: 'Done',
  shareToCourseNothing:
    'There are no published microreels to add yet. Publish them first.',
  shareToCourseError: 'The microreels could not be added to the course',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  back: 'Back',
  editQuestionTitle: 'Edit question',
  noQuestionToEdit: 'This microreel has no question to edit yet',
  noActionsTooltip: 'No actions were added to this Microreel.',
  editQuestionSubtitle: (index: number, reelTitle: string) =>
    `Microreel ${index} · ${reelTitle}`,
  questionLabel: 'Question',
  answersLabel: 'Answers',
  answersHint:
    'Click the text to edit it, tap a circle to mark the correct one.',
  answerPlaceholder: 'Answer text',
  addAnswer: 'Add answer',
  maxAnswersHint: (max: number) => `A question can have up to ${max} answers`,
  duplicateAnswersWarning: 'Answers must be unique — edit the repeated ones',
  deleteAnswer: 'Delete answer',
  markCorrect: 'Mark as the correct answer',
  answersSummary: (count: number) =>
    `${count} ${count === 1 ? 'answer' : 'answers'} · one marked correct`,
  answersSummaryNoCorrect: (count: number) =>
    `${count} ${count === 1 ? 'answer' : 'answers'} · mark the correct one`,
  saveQuestion: 'Save question',
  savingQuestion: 'Saving…',
  questionSaved: 'Question updated',
  phoneQuizTitle: "Let's test your knowledge",
  phoneQuizSubtitle: 'Answer these questions correctly',
  phoneQuizFinish: 'Submit answer',
  phoneQuizContinue: 'Continue',
  phoneQuizCorrect: 'Correct!',
  phoneQuizIncorrect: 'Not quite',
  phoneQuizExplanation: 'Answer explanation',
  shownAtCaption: (time: string) => `Shown at ${time}, after the last scene`,
  shownAtCaptionNoTime: 'Shown after the last scene',
  exitPreview: 'Exit preview',
  phoneAckHeading: 'Before you continue',
  phoneAckSubtitle: 'Please confirm to complete this microreel',
  phoneAckButton: 'I acknowledge',
  phoneAckQuestion: 'Click Yes to acknowledge you have watched the Microreel',
  phoneAckYes: 'Yes',
  phoneAckNo: 'No',
};
